<template>
  <div class="create-board-preview-survey-form">
    <div class="row text-center">
      <el-radio-group v-model="previewSize" size="small">
        <el-radio-button label="1300">Desktop</el-radio-button>
        <el-radio-button label="1000">Tablet</el-radio-button>
        <el-radio-button label="412">Mobile</el-radio-button>
      </el-radio-group>
    </div>

    <div class="row text-center" v-if="!survey.isPreview">
      Published Link:
      <a target="_blank" :href="publishedUrl">{{ publishedUrl }}</a>
    </div>

    <div class="row text-center">
      External Preview Link:
      <a target="_blank" :href="previewUrl">{{ previewUrl }}</a>
    </div>

    <div class="row text-center">
      <iframe
        :src="previewUrl"
        :width="previewSize"
        height="600"
        frameborder="0"
        ref="previewFrame"
      ></iframe>
    </div>
    <div class="row text-center">
      <el-button type="primary" :disabled="!survey.isPreview" :loading="surveySaving" @click="handlePublish">
        <i class="fa fa-fw fa-check-square-o"></i> {{ publishedTitle() }}
      </el-button>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'CreateBoardPreviewSurveyForm',
  data: () => ({
    previewSize: '412',
  }),
  computed: {
    ...mapState('surveybuilder', ['survey', 'surveySaving', 'surveySaveSuccess']),

    previewUrl() {
      return `${process.env.API_COLONY_V2}/surveys/preview/${this.survey.id}`;
    },

    publishedUrl() {
      return this.survey.url;
    },
  },
  methods: {
    reloadPreview() {
      // Touch the src of the iframe to reload it
      this.$refs.previewFrame.src += '';
    },

    publishedTitle() {
      return !this.survey.isPreview ? 'Published' : 'Publish';
    },

    handlePublish() {
      const publishSurvey = { id: this.survey.id, isPreview: false, isActive: true };
      this.$store.dispatch('surveybuilder/surveyUpdate', publishSurvey);
    },
  },
};
</script>



// WEBPACK FOOTER //
// PreviewTab.vue?590e962c